module.exports = __webpack_public_path__ + "img/logo.d937c093.png";